import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { KeycloakService, KeycloakEventTypeLegacy  } from 'keycloak-angular';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'frontend';

  constructor(private keycloakService: KeycloakService) {}

ngOnInit(): void {
    this.keycloakService.keycloakEvents$.subscribe(event => {
      // Use Legacy enum
      if (event.type === KeycloakEventTypeLegacy.OnTokenExpired) {
        this.keycloakService.login();
      }
    });
  }
}
